import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import config from '../config'

export default function ScrollToTop() {
    const { pathname } = useLocation()

    useEffect(() => {
        if (pathname === config.root) return
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant",
        });
    }, [pathname])

    return null
}